import { useEffect, useState } from "react";
import { getToken } from "../../../services/authService";

// Titulares de arma: tipoPersona === "TITULAR".
export function useTitularesData() {
    const [loading, setLoading] = useState(true);
    const [personas, setPersonas] = useState([]);
    const [error, setError] = useState(null);

    useEffect(() => {
        let mounted = true;

        (async () => {
            setLoading(true);
            setError(null);
            try {
                const token = getToken();
                const headers = { Authorization: `Bearer ${token}` };
                const res = await fetch(`${process.env.REACT_APP_API_URL}/api/personas/all`, { headers });
                if (!res.ok) throw new Error(await res.text());
                const data = await res.json();
                const titulares = (Array.isArray(data) ? data : []).filter(
                    (p) => p?.tipoPersona === "TITULAR"
                );
                if (mounted) setPersonas(titulares);
            } catch (e) {
                if (mounted) setError(e?.message || "Error cargando titulares");
            } finally {
                if (mounted) setLoading(false);
            }
        })();

        return () => {
            mounted = false;
        };
    }, []);

    return { loading, personas, error };
}
